import * as React from 'react';
import { createElement } from 'react';
import {
  DashboardMenuItem,
  Menu,
  MenuItemLink,
  useResourceDefinitions,
  useSidebarState
} from 'react-admin';
import { ViewList, ManageAccounts } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import TokenService from '../../../services/TokenService';

export const CustomMenu = (props) => {
  const resources = useResourceDefinitions();
  const [open] = useSidebarState();
  const param = useParams();
  const resource = param['*'].split('/')[0];
  const merchantID = TokenService.getLocalMerchantID();
  return (
    <Menu {...props}>
      <DashboardMenuItem
        selected={resource === 'dashboard'}
        primaryText={
          <Typography
            variant={'dashboard' === resource ? 'h5' : 'body1'}
            color="inherit"
          >
            Dashboard
          </Typography>
        }
        to={`/dashboard`}
      />
      {Object.keys(resources).map((name) => (
        <Box key={name}>
          <MenuItemLink
            selected={name === param['*']}
            // to={`/${name}`}
            to={name !== "Merchant" ? `/${name}` : `${name + '/' + merchantID} `}
            primaryText={
              <Typography
                variant={name === resource ? 'h5' : 'body1'}
                color="inherit"
              >
                {(resources[name].options && resources[name].options.label) ||
                  name}
              </Typography>
            }
            leftIcon={
              resources[name].icon ? (
                createElement(resources[name].icon)
              ) : (
                <ViewList />
              )
            }
            onClick={props.onMenuClick}
            sidebarIsOpen={open}
          />
        </Box>
      ))}

      {/* Custom menus here */}
      <MenuItemLink
        primaryText={
          <Typography
            variant={'edit-profile' === param['*'] ? 'h5' : 'body1'}
            color="inherit"
          >
            Profile
          </Typography>
        }
        selected={param['*'] === 'edit-profile'}
        to="/edit-profile"
        leftIcon={<ManageAccounts />}
        hidden
      />
    </Menu>
  );
};
